
document.addEventListener('DOMContentLoaded', function () {
const tabHeadings = document.querySelectorAll('.solution-tab-heading');
const tabContents = document.querySelectorAll('.solution-tab-content');
const imageBlocks = document.querySelectorAll('.solution-tab-image-wrapper');
const toggleButton = document.querySelector('.toggle-tabs');
const headingContainer = document.querySelector('.solution-tab-heading_container');

tabHeadings.forEach(tabHeading => {
    tabHeading.addEventListener('click', () => {
    const id = tabHeading.getAttribute('data-id');

    // Remove active class from all tabs and content
    tabHeadings.forEach(t => t.classList.remove('tab--active'));
    tabContents.forEach(c => c.classList.remove('tab--active'));
    imageBlocks.forEach(i => i.classList.remove('tab--active'));

    // Add active class to clicked tab and matching content/image
    tabHeading.classList.add('tab--active');
    document.querySelectorAll(`.solution-tab-content[data-id="${id}"]`).forEach(el => el.classList.add('tab--active'));
    document.querySelectorAll(`.solution-tab-image-wrapper[data-id="${id}"]`).forEach(el => el.classList.add('tab--active'));
    });
});

// Toggle view all/view less
// Toggle view all/view less
if (toggleButton) {
    toggleButton.addEventListener('click', () => {
    headingContainer.classList.toggle('collapsed');
    toggleButton.textContent = headingContainer.classList.contains('collapsed') ? 'View all' : 'View less';
    });
}

});